import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { fetchNotifications } from '../../redux/actions/notification_actions';
import { fetchAllUsers } from '../../redux/actions/user_actions';
import Test from './test';

const mSTP = state => ({
  notifications: Object.values(state.notifications),
  users: Object.values(state.users),
  currentUserId: state.session.user.id,
  currentUser: state.session.user.username
});

const mDTP = dispatch => ({
  fetchNotifications: () => dispatch(fetchNotifications()),
  fetchAllUsers: () => dispatch(fetchAllUsers()),
});

export default withRouter(connect(mSTP, mDTP)(Test));